<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
window.onload = function() {
  document.addEventListener('touchstart', function(e) {
    console.log("1",e.touches.length)
    if (e.touches.length > 1) {
      e.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function(e) {
    console.log("2")
    e.preventDefault()
  })
}
export default {
  data(){

  },
  methods:{

  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
img {
  -webkit-user-drag: none; /* for Chrome, Safari, Opera */
  -khtml-user-drag: none; /* for Konqueror browsers */
  -moz-user-drag: none; /* for Firefox */
  -ms-user-drag: none; /* for IE/Edge */
  user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
body {
  -webkit-user-select: none; /* Safari, Chrome 和 Opera */
  -moz-user-select: -moz-none; /* Firefox */
  -ms-user-select: none; /* IE 和 Edge */
  user-select: none; /* 标准语法，但目前支持有限 */
}
</style>
